//const apiUrlBase = "http://localhost:8001"
const apiUrlBase = 'https://api.jsparrow.uk'

export default apiUrlBase